@import '~style-sheet-helpers/core.less';

.pill {
  margin: 0 5px;
}

.tag-name {
  font-weight: 500;
}

.tag-menu-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.tag-menu {
  margin-left: 5px;
}

.order-placed-menu {
  min-width: 30px;
}

.order-placed-item {
  padding: 10px;
  min-width: 50px;
}
